import EmptyMemberList from './EmptyList';

export default EmptyMemberList;
